import React, { createContext, useContext, useState, useEffect } from 'react';
import { translations } from '../data/translations';

const LanguageContext = createContext();

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};

const detectBrowserLanguage = () => {
  const browserLang = navigator.language || navigator.userLanguage;
  const langCode = browserLang.split('-')[0].toLowerCase();
  
  // Check if we support this language
  if (['en', 'nl', 'tr'].includes(langCode)) {
    return langCode;
  }
  
  // Default to English
  return 'en';
};

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(() => {
    // Check localStorage first
    const saved = localStorage.getItem('portfolio-language');
    if (saved && ['en', 'nl', 'tr'].includes(saved)) {
      return saved;
    }
    // Then detect browser language
    return detectBrowserLanguage();
  });

  useEffect(() => {
    localStorage.setItem('portfolio-language', language);
    // Update html lang attribute for SEO
    document.documentElement.lang = language;
  }, [language]);

  const t = (path) => {
    const keys = path.split('.');
    let result = translations[language] || translations.en;
    for (const key of keys) {
      result = result?.[key];
    }
    return result || path;
  };

  const changeLanguage = (lang) => {
    if (['en', 'nl', 'tr'].includes(lang)) {
      setLanguage(lang);
    }
  };

  return (
    <LanguageContext.Provider value={{ language, t, changeLanguage }}>
      {children}
    </LanguageContext.Provider>
  );
};
